import './App.css';
import GetSlots from './Slots';

function App() {
  return (
    <div className="App">
      <GetSlots/>
    </div>
  );
}

export default App;
